import { useMemo } from 'react'
import { WappRoom } from '@weblite/ts-action/wapp-room'
import { useSelector } from 'react-redux'
import { getWappRoom } from '$logic/wapp-room/service'
import { createUseEntity } from '$func/create-use-entity.react-hook'
import { RootState } from '$setup/redux'
import { wappRoomsStorage } from '$logic/wapp-room/storage'

const getWappRoomsView = (state: RootState): Record<string, WappRoom> =>
  state.main.wappRooms

const getWappRoomView = (roomId: string) => (state: RootState) =>
  state.main.wappRooms[roomId]

export const useWappRoom = createUseEntity<WappRoom>(
  getWappRoomView,
  getWappRoom,
)

export function useWappRooms() {
  return useSelector(getWappRoomsView)
}

export function useWappRoomSync(roomId: string) {
  return useSelector(getWappRoomView(roomId))
}

export function useWappRoomByWappId(wappId: string) {
  const wappRoom = useMemo(
    () => wappRoomsStorage.getAll().find(wr => wr.wappId === wappId),
    [wappId],
  )

  return useWappRoom(wappRoom?.roomId)
}
